var exports = {
  "o": "ForumPostActions.module__actions___MlFfNn",
};

module.exports = exports;
